import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function createCarousel(block, config) {
	const viewport = block.querySelector(config.viewport);
	const track = block.querySelector(config.track);
	const prevBtn = block.querySelector(config.prevBtn);
	const nextBtn = block.querySelector(config.nextBtn);

	if (!viewport || !track) return;

	const slides = track.querySelectorAll(config.slide);
	if (slides.length === 0) return;

	let swiper = null;

	function getSlidesPerView() {
		const w = window.innerWidth;
		if (w < config.tabletBreakpoint) return 1;
		if (w < config.desktopBreakpoint) return 2;
		return 3;
	}

	function init() {
		if (swiper) return;
		const slidesPerView = getSlidesPerView();
		if (slides.length <= slidesPerView) return;

		track.style.justifyContent = '';
		track.style.width = '';
		track.style.gap = '0';
		track.style.transform = '';
		slides.forEach((s) => { s.style.width = ''; s.style.marginRight = ''; s.style.marginLeft = ''; });
		if (prevBtn) prevBtn.style.display = '';
		if (nextBtn) nextBtn.style.display = '';

		swiper = new Swiper(viewport, {
			modules: [Navigation],
			wrapperClass: config.track.substring(1),
			slideClass: config.slide.substring(1),
			slidesPerView: 1,
			spaceBetween: config.spaceBetween,
			loop: true,
			loopedSlides: 3,
			speed: 400,
			watchOverflow: false,
			breakpoints: {
				0: { slidesPerView: 1, spaceBetween: config.spaceBetween },
				[config.tabletBreakpoint]: { slidesPerView: 2, spaceBetween: config.spaceBetween },
				[config.desktopBreakpoint]: { slidesPerView: 3, spaceBetween: config.spaceBetween }
			},
			navigation: {
				prevEl: prevBtn,
				nextEl: nextBtn
			},
			on: {
				init() {
					track.style.gap = '0';
				}
			}
		});
	}

	function destroy() {
		if (swiper) {
			swiper.destroy(true, true);
			swiper = null;
		}
		track.style.justifyContent = 'center';
		track.style.gap = '';
		track.style.transform = '';
		slides.forEach((s) => {
			s.style.width = '';
			s.style.marginRight = '';
			s.style.marginLeft = '';
		});
		if (prevBtn) prevBtn.style.display = 'none';
		if (nextBtn) nextBtn.style.display = 'none';
	}

	function handleResize() {
		const slidesPerView = getSlidesPerView();
		if (slides.length <= slidesPerView) {
			destroy();
		} else if (swiper) {
			swiper.update();
		} else {
			init();
		}
	}

	const slidesPerView = getSlidesPerView();
	if (slides.length <= slidesPerView) {
		track.style.justifyContent = 'center';
		track.style.gap = '';
		if (prevBtn) prevBtn.style.display = 'none';
		if (nextBtn) nextBtn.style.display = 'none';
	} else {
		init();
	}

	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(handleResize, 200);
	});
}

export function initAllCarousels() {
	/*
	document.querySelectorAll('.product-carousel').forEach((block) => {
		if (block.dataset.swiperInit) return;
		block.dataset.swiperInit = '1';
		createCarousel(block, {
			viewport: '.product-carousel-viewport',
			track: '.product-carousel-track',
			slide: '.product-card',
			prevBtn: '.product-carousel-nav-prev',
			nextBtn: '.product-carousel-nav-next',
			spaceBetween: 24,
			tabletBreakpoint: 980,
			desktopBreakpoint: 1140
		});
	});
	*/

	// Hide nav arrows for product carousel (no Swiper)
	document.querySelectorAll('.product-carousel-nav-prev, .product-carousel-nav-next').forEach((btn) => {
		btn.style.display = 'none';
	});

	document.querySelectorAll('.testimonials-carousel').forEach((block) => {
		if (block.dataset.swiperInit) return;
		block.dataset.swiperInit = '1';
		createCarousel(block, {
			viewport: '.testimonials-carousel-viewport',
			track: '.testimonials-carousel-track',
			slide: '.testimonials-card',
			prevBtn: '.testimonials-nav-prev',
			nextBtn: '.testimonials-nav-next',
			spaceBetween: 16,
			tabletBreakpoint: 992,
			desktopBreakpoint: 1200
		});
	});


}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initAllCarousels);
} else {
	initAllCarousels();
}
